export const DISEASE_LABELS = {
  "exam": {
    "true": "Pode exigir exames complementares",
    "false": "Sem exames complementares",
  },
  "emergency": {
    "true": "Emergencial",
    "false": "Não emergencial",
  },
  "castration": {
    "true": "Castração influencia",
    "false": "Castração não influencia",
  },
  "contagious": {
    "true": "Contagioso para outros animais",
    "false": "Não contagioso para outros animais",
  },
  "transmissible": {
    "true": "Transmissível para humanos",
    "false": "Não transmissível para humanos",
  },
};

function isBoolean(value) {
  return typeof value === "boolean" || value === "true" || value === "false";
}

export function getDiseaseLabels(labels) {
  if (!labels) return [];

  if (typeof labels === "string") {
    labels = JSON.parse(labels);
  }

  if (
    !isBoolean(labels.exam) ||
    !isBoolean(labels.emergency) ||
    !isBoolean(labels.transmissible) ||
    !isBoolean(labels.contagious) ||
    !isBoolean(labels.castration)
  ) {
    return [];
  }

  return Object.entries(labels).sort((a, b) => {
    if (a[0] === "emergency") return -1;
    if (b[0] === "emergency") return 1;
    return 0;
  });
}

export function getPetIcon(species) {
  switch (species) {
    case "Felinos":
      return "mdi-cat";
    case "Caninos":
      return "mdi-dog";
    default:
      return "mdi-paw";
  }
}

const SPECIES_MAP = {
  cats: "Felinos",
  dogs: "Caninos",
};

export function getDiseaseSpecies(species) {
  if (!species) return [];
  if (typeof species === "string") {
    species = JSON.parse(species);
    if (!Array.isArray(species)) return [];
  }

  return [
    ...new Set(species.map((o) =>
      SPECIES_MAP[o.toLowerCase()] ??
        "Outro"
    )),
  ];
}

export function parsePossibleObject(line) {
  if (!line.trim()) return;

  const parsed = JSON.parse(line);

  if (!parsed || typeof parsed !== "object") {
    throw new Error();
  }

  if ("exception" in parsed) {
    throw new Error(parsed.exception);
  }

  return parsed;
}
